import React, { ReactNode, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import actions from '@nal/components/Auth/store/actions';
import { getToken } from '@nal/helpers/utility';
declare var window: Window;

type AuthGuardPropType = {
    idToken?: string;
    children?: ReactNode;
};

const AuthGuard: React.FC<AuthGuardPropType> = (props) => {
    const history = useHistory();
    const { children } = props;
    const idToken = getToken();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const search = location.search.substring(1);
        const searchParams = new URLSearchParams(search);
        const token = searchParams.get('token');
        const isPopup = searchParams.get('isPopup');

        if (token) {
            searchParams.delete('token');
            if (isPopup) {
                searchParams.delete('isPopup');
                try {
                    searchParams.append('token', token);
                    window.opener.location.href = _.trimEnd(location.pathname, '/') + '?' + searchParams.toString();
                    window.close();
                } catch (error) {
                    console.log(error);
                    setTimeout(() => {
                        global.parent.localStorage.setItem('id_token', token);
                        global.window.close();
                    }, 1000);
                }

                return () => {};
            }

            dispatch({
                type: actions.SOCIAL_LOGIN_SUCCESS,
                payload: {
                    token,
                    url: _.trimEnd(location.pathname, '/') + '?' + searchParams.toString(),
                },
                history,
            });

            dispatch({ type: 'GET_ME' });
        } else if (!idToken) {
            const { pathname, search } = location;
            history.push({
                pathname: '/auth/login',
                search: `?back_url=${encodeURIComponent(pathname + search)}`,
            });
        }
    });

    return <React.Fragment>{children}</React.Fragment>;
};

export default AuthGuard;
